module.exports = __webpack_public_path__ + "img/award_icon_jf.c36ade9b.png";